export default __webpack_public_path__ + "static/media/Banner3_revamp_En.33fe5e8a.webp";